import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '',
  //   redirect: '/login',
  // }, 
  {
    path: '*',
    redirect: '/login',
  }, 
  {
    path: '/log-in',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => {
      return import('@/views/Login.vue')
    },
    meta: {
      title: 'Login'
    }
  },
  {
    path: '/sign-up',
    name: 'Sign Up',
    component: () => {
      return import('@/views/Sign-up.vue')
    },
    meta: {
      title: 'Sign Up'
    }
  },
  {
    path: '/patients',
    name: 'Dashboard',
    component: () => {
      return import('@/views/Patients.vue')
    },
    meta: {
      requiresAuth: true,
      title: 'Patients'
    }
  },
  { // plan/playlists viewing screen
    path: '/templates',
    name: 'Templates',
    component: () => {
      return import('@/components/templateTabs')
    },
    meta: {
      requiresAuth: true,
      title: 'Templates'
    }
  },

  { // employees click invite email, leading here
    path: '/register',
    name: 'EmployeeRegister',
    component: () => {
      return import('@/views/EmployeeRegister')
    },
    meta: {
      title: 'Register'
    }
  },
  { // owners can manage their therapists
    path: '/account',
    name: 'Account',
    component: () => {
      return import('@/views/Account')
    },
    meta: {
      requiresAuth: true,
      title: 'Account'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

import store from '@/store'

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) { // set title, if there is one
    document.title = `Aceso | ${to.meta.title}`;
  }
  if (to.matched.some(record => record.meta.requiresAuth)) { // auth route locking
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    const loggedIn = store.state.auth.user;
    if (!loggedIn) {
      next({
        path: '/log-in',
        query: { redirect: to.path }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})


export default router